const getDashboardObject = (theme) => {
  return {
    navBarIconStyle: {
      width: "18px",
      marginRight: "8px",
    },
    inlineStyle: { marginTop: "15px" },
    headingStyle: {
      fontSize: "32px",
      color: "var(--text-primary, rgba(0, 0, 0, 0.87))",
      fontWeight: 400,
      lineHeight: "40px",
      letterSpacing: "-0.5px",
    },
    subHeadingStyle: {
      marginTop: "10px",
      marginBottom: "15px",
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: "rgba(84, 110, 122, 1)",
    },
    assessmentButton: {
      border: "1px solid #0D47A1",
      borderRadius: "5px",
      marginLeft: { lg: "5px", md: "5px", xs: "0", sm: "0" },
      padding: {
        lg: "5px 10px 5px 10px",
        md: "5px 10px 5px 10px",
        xs: "5px",
        sm: "5px",
      },
    },
    tablePatientName: {
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px",
      letterSpacing: "0.17px",
      color: "#0D47A1",
      textDecoration: "underline",
    },
    tableColumnHeader: {
      fontSize: "16px",
      fontWeight: 400,
      lineHeight: 24,
      color: "rgba(0, 0, 0, 0.87)",
    },
    tablePatientDOBMRN: {
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "18px",
      letterSpacing: "1px",
      color: "#546E7A",
      paddingTop: "4px",
    },
    assessmentButtonText: {
      color: "#0D47A1",
      size: "15px",
      fontWeight: 400,
      lineHeight: "26px",
      letterSpacing: "0.46px",
    },
    addPatientButtonMrn: {
      border: "1px solid #0D47A1",
      borderRadius: "5px",
      padding: "5px 10px 5px 10px",
    },
    addPatientButtonText: {
      textColour: "#0D47A1",
      size: "15px",
      fontWeight: 400,
      lineHeight: "26px",
      letterSpacing: "0.46px",
    },
    tableStyle: {
      minHeight: "85vh",
      maxWidth: "1400px",
      width: "100%",
      margin: "0px auto",
      padding: "0 40px",
    },
    addPatientTableStyle: {
      boxShadow: "0px 0px",
      minHeight: "70vh",
      maxWidth: "1200px",
      width: "100%",
      margin: "25px auto",
      padding: "0 40px",
    },
    emptyDashboardStyle: { marginTop: "4%" },
    patientTextStyle: {
      fontWeight: 400,
      fontSize: "32px",
      lineHeight: "40px",
      letterSpacing: "-0.5px",
      color: "var(--text-primary, #000000DE)",
    },
    patientTableStyle: {
      minHeight: "65vh",
      maxWidth: "1200px",
      width: "100%",
      margin: "20px auto",
      padding: { lg: "0 30px", md: "0 30px", xs: "0", sm: "0" },
    },
    tableContentStyle: {
      boxShadow: "0px 0px",
      padding: {
        lg: "10px 20px 0px 20px",
        md: "10px 20px 0px 20px",
        xs: "0",
        sm: "0",
      },
    },

    gridAlign: {
      alignItems: { xs: "left", sm: "center" },
      margin: "0 0 15px",
    },
    patientDashboardNoPatient: {
      fontWeight: 400,
      fontSize: "24px",
      lineHeight: "32px",
      color: "#030404",
    },
    patientDashboardText: {
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "24px",
      color: "#546E7A",
    },
    searchPatientStyle: {
      alignItems: { lg: "center", md: "center" },
      // margin: "0 0 15px",
    },
    searchImageStyle: { marginBottom: "20px" },
    backBtnText: {
      fontSize: "14px",
      lineHeight: "24px",
      letterSpacing: "1px",
      color: theme.textColour.primaryColor,
      fontWeight: 600,
    },
    backBtn: {
      cursor: "pointer",
      width: "65px",
      margin: "25px 20px 5px 0px",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
    },
    patientHeading: {
      fontSize: "24px",
      fontWeight: 500,
      letterSpacing: "1px",
      lineHeight: "32px",
      color: theme.textColour.headingColour,
      margin: "20px 0",
    },
    addPatientButton: {
      padding: "9px 22px",
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "1px",
      backgroundColor: theme.textColour.primaryColor,
    },
    loadingLeftStyle: {
      position: "absolute",
      top: "50%",
      left: "50%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      transform: "translate(-50%, -50%)",
    },
    loadinText: {
      fontSize: "14px",
      color: theme.textColour.textTertiary,
      fontWeight: 400,
      lineHeight: "22px",
      letterSpacing: ".5px",
    },
    dispBlk: {
      [theme.breakpoints.down("sm")]: { display: "block", width: "100%" },
    },
    list: { width: 250 },
    navbarLogoutStyle: {
      color: theme.custom.activeNavLink,
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      cursor: "pointer",
      marginRight: "10px",
      float: "right",
      fontSize: "14px",
      fontWeight: 500,
      letterSpacing: 1,
      [theme.breakpoints.down("xs")]: { float: "left", padding: "0px" },
    },
    appBar: {
      // borderTop: `7px solid #FFD100`,
      borderBottom: "3px solid #ECEEF0",
      backgroundColor: "#fff",
      height: "89px",
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
    },
    menuButton: {
      padding: "12px",
      marginLeft: { xs: "10px" },
      height: 46,
      color: theme.custom.activeNavLink,
    },
    prescriptionLink: {
      color: "#2f363cc4",
      padding: "15px 20px",
      ":hover": { background: "#0000000a", color: "#00446b" },
    },
  };
};

const insuranceCoverageDetailsObject = (theme) => {
  let insuranceCoverageObject = getDashboardObject(theme);
  insuranceCoverageObject.dialogHeading = {
    fontSize: "18px",
    color: theme.textColour.headingColour,
    lineHeight: "21.09px",
    letterSpacing: "0.15px",
    fontWeight: 600,
  };
  insuranceCoverageObject.dialogbtnStyle = {
    margin: "5px",
    cursor: "pointer",
    fontSize: "14px",
    color: theme.textColour.primaryColor,
    lineHeight: "24px",
    letterSpacing: "1px",
    fontWeight: 600,
  };
  insuranceCoverageObject.dialogBodytext = {
    textAlign: "justify",
    fontSize: "14px",
    color: theme.textColour.dialogBodytext,
    lineHeight: "22px",
    letterSpacing: "0.5px",
    fontWeight: 400,
  };
  return insuranceCoverageObject;
};

let addNewPatientStyleObject = (theme) => {
  let addPatient = getDashboardObject(theme);
  addPatient.loadingInsuranceStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%,-50%)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  };
  addPatient.gridCAlign = { alignItems: "center" };
  addPatient.searchHeaderText = {
    fontSize: "24px",
    lineHeight: "32px",
    color: "#030404",
    fontWeight: 400,
  };
  addPatient.searchparagraphText = {
    fontSize: "16px",
    lineHeight: "24px",
    color: "#546E7A",
    fontWeight: 400,
  };
  addPatient.paginationStyle = {
    marginLeft: "20%",
    marginRight: "20%",
    marginTop: "4%",
    [theme.breakpoints.down("sm")]: { marginLeft: "0px", marginRight: "0px" },
  };
  addPatient.previousStyle = {
    fontSize: "4px",
    height: "60px",
    left: 0,
    position: "absolute",
    width: "150px",
  };
  addPatient.paginationPage = { fontWeight: "700" };
  addPatient.nextStyle = {
    fontSize: "4px",
    height: "60px",
    position: "absolute",
    right: 0,
    width: "150px",
  };
  addPatient.disabledItemStyle = { color: "#d3d3d3" };
  addPatient.activeItem = {
    border: "solid 1px #808e9b",
    height: "40px",
    width: "40px",
    borderRadius: "20px",
    color: "#fff",
    backgroundColor: "#00446B",
  };
  addPatient.paginationContainer = {
    display: "flex",
    flexDirection: "row",
    height: "40px",
    justifyContent: "center",
    listStyleType: "none",
    position: "relative",
  };
  addPatient.itemStyle = {
    alignItems: "center",
    cursor: "pointer",
    display: "flex",
    fontSize: "14px",
    height: "40px",
    justifyContent: "center",
    width: "40px",
  };
  addPatient.inputItem = { width: "100%" };

  addPatient.gridAlign = { alignItems: "center", margin: "10px 0" };
  addPatient.reloadinIconStyle = {
    fontSize: "14px",
    height: "18px",
    width: "16px",
    marginRight: "6px",
    marginTop: "3px",
  };
  addPatient.buttonStyle = {
    width: "100%",
    display: "block",
    margin: 0,
  };
  addPatient.noResultTextStyle = {
    width: "100%",
    display: "block",
    margin: "0px 0px 0px 5px",
  };
  addPatient.searchButtonStyle = {
    marginLeft: "20px",
    width: "130px",
    padding: "13px 22px",
    [theme.breakpoints.down("sm")]: { marginLeft: "0px" },
  };
  addPatient.tableStyle = {
    maxWidth: "900px",
    margin: "0 auto",
    padding: "0",
  };
  addPatient.selectButtonStyle = {
    fontSize: "14px",
    color: theme.textColour.primaryColor,
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: "1px",
    padding: "6px",
  };
  addPatient.headerStyle = {
    cursor: "pointer",
    margin: "25px 20px 5px 0px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  };

  return addPatient;
};
export const getDashboardStyle = getDashboardObject;
export const addPatientStyleStyle = addNewPatientStyleObject;

export const insuranceCoverageDetailsStyle = insuranceCoverageDetailsObject;
